//GeneratorFlag:[NoChange]
import PersonRole from './person-role';
import Tenant from './tenant';

export default {PersonRole, Tenant}
export{PersonRole, Tenant}